export type RowActionVariant = 'panel' | 'edit' | 'danger' | 'neutral' | 'success';

export interface RowActionDefinition {
  variant: RowActionVariant;
  icon: string;
  title: string;
}

export const ROW_ACTIONS = {
  recalculate: { variant: 'danger', icon: 'refresh-cw', title: 'Recalcular Fechamento' },
  creditAdjust: { variant: 'neutral', icon: 'credit-card', title: 'Ajuste de crédito' },
  exportTransactions: { variant: 'success', icon: 'file-spreadsheet', title: 'Exportar Transações' },
  unapprove: { variant: 'danger', icon: 'x', title: 'Desaprovar' },
  exportPdf: { variant: 'panel', icon: 'file-text', title: 'Exportar PDF' },
  information: { variant: 'edit', icon: 'info', title: 'Mais informações' },
  receipt: { variant: 'success', icon: 'receipt', title: 'Baixar comprovante' },
  finish: { variant: 'success', icon: 'dollar-sign', title: 'Finalizar' },
  operations: { variant: 'panel', icon: 'settings', title: 'Operações' },
  devices: { variant: 'neutral', icon: 'monitor', title: 'Dispositivos' },
  synchronize: { variant: 'success', icon: 'settings-2', title: 'Sincronizar' },
  consumption: { variant: 'panel', icon: 'menu', title: 'Consumação' },
  add: { variant: 'success', icon: 'plus', title: 'Adicionar' },
  subtract: { variant: 'danger', icon: 'minus', title: 'Retirar' },
  qrCode: { variant: 'panel', icon: 'qr-code', title: 'Ver QR Code' },
  payments: { variant: 'panel', icon: 'badge-dollar-sign', title: 'Pagamentos' },
  dashboard: { variant: 'panel', icon: 'chart-column', title: 'Painel' },
  edit: { variant: 'edit', icon: 'pencil', title: 'Editar' },
  details: { variant: 'edit', icon: 'eye', title: 'Detalhes' },
  remove: { variant: 'danger', icon: 'trash-2', title: 'Excluir' },
  duplicate: { variant: 'neutral', icon: 'copy', title: 'Duplicar' },
  approve: { variant: 'success', icon: 'check', title: 'Aprovar' },
  refuse: { variant: 'danger', icon: 'x', title: 'Recusar' },
  download: { variant: 'success', icon: 'download', title: 'Baixar' },
  downloadXml: { variant: 'success', icon: 'file-code', title: 'Baixar XML' },
  export: { variant: 'success', icon: 'external-link', title: 'Exportar' },
  link: { variant: 'panel', icon: 'link', title: 'Vincular' },
  more: { variant: 'neutral', icon: 'ellipsis', title: 'Mais ações' },
  witnesses: { variant: 'neutral', icon: 'users', title: 'Testemunhas' },
  cancel: { variant: 'danger', icon: 'circle-x', title: 'Cancelar' },
  register: { variant: 'success', icon: 'notebook-pen', title: 'Registrar' },
  sign: { variant: 'panel', icon: 'square-pen', title: 'Assinar' },
  resetPassword: { variant: 'neutral', icon: 'key', title: 'Resetar Senha' },
  registerCustomer: { variant: 'success', icon: 'sticky-note', title: 'Cadastrar novo cliente' },
  tickets: { variant: 'panel', icon: 'ticket', title: 'Ingressos' },
  transactions: { variant: 'edit', icon: 'arrow-left-right', title: 'Visualizar Transações' },
  verify: { variant: 'success', icon: 'circle-check', title: 'Verificar' },
  unverify: { variant: 'danger', icon: 'circle-x', title: 'Remover Verificação' },
  history: { variant: 'edit', icon: 'history', title: 'Histórico' }
} satisfies Record<string, RowActionDefinition>;

export type RowActionName = keyof typeof ROW_ACTIONS;
